/**
 * Presentation-only copy of the server's permission resolver
 * (wp-qa-testing-dashboard-api/src/permissions.js). Keep the two IDENTICAL.
 * The server enforces these gates for real; this copy just decides what to render.
 *
 * Owner  -> every gate
 * Admin  -> every gate except viewBilling / deleteOrg / grantAdmin
 * Developer -> quarantine only (+ implicit read access everywhere)
 */

export const GATES = [
  'viewBilling',
  'deleteOrg',
  'manageMembers',
  'grantAdmin',
  'manageKeys',
  'revealKeys',
  'manageIntegrations',
  'manageProjects',
  'viewAllProjects',
  'assignOwners',
  'quarantine',
  'abortRuns',
  'viewAllTriage',
];

const OWNER_ONLY = new Set(['viewBilling', 'deleteOrg', 'grantAdmin']);

export function resolvePermissions(role) {
  const r = String(role || '').toLowerCase();
  if (r === 'owner') return Object.fromEntries(GATES.map((g) => [g, true]));
  if (r === 'admin') return Object.fromEntries(GATES.map((g) => [g, !OWNER_ONLY.has(g)]));
  return Object.fromEntries(GATES.map((g) => [g, g === 'quarantine']));
}
